import { getCitiesForProvince, provinceNeedsCityPicker } from './provinceCities'

const PRIMARY_KEY = 'selected_region_primary'
const CITY_KEY = 'selected_region_city'
/** 与历史版本兼容：始终写入接口使用的地区字符串（有市则存市名） */
const LEGACY_KEY = 'selected_region'

function getApiRegionFromParts(primary, city) {
  const p = (primary || '').trim() || '全国'
  if (p === '全国') return '全国'
  if (provinceNeedsCityPicker(p) && (city || '').trim()) {
    return String(city).trim()
  }
  return p
}

function persistState(primary, city) {
  const p = (primary || '').trim() || '全国'
  let c = (city || '').trim()
  if (!provinceNeedsCityPicker(p)) {
    c = ''
  } else {
    const list = getCitiesForProvince(p) || []
    if (!c || !list.includes(c)) {
      c = list[0] || ''
    }
  }
  localStorage.setItem(PRIMARY_KEY, p)
  localStorage.setItem(CITY_KEY, c)
  localStorage.setItem(LEGACY_KEY, getApiRegionFromParts(p, c))
}

function readPersistedState() {
  let primary = localStorage.getItem(PRIMARY_KEY)
  let city = localStorage.getItem(CITY_KEY)

  if (!primary) {
    const legacy = (localStorage.getItem(LEGACY_KEY) || '').trim()
    if (legacy) {
      primary = legacy
      if (provinceNeedsCityPicker(primary)) {
        const list = getCitiesForProvince(primary) || []
        city = list[0] || ''
      } else {
        city = ''
      }
      persistState(primary, city)
    } else {
      primary = '全国'
      city = ''
      persistState(primary, city)
    }
  } else {
    primary = primary.trim() || '全国'
    city = (city || '').trim()
    if (provinceNeedsCityPicker(primary)) {
      const list = getCitiesForProvince(primary) || []
      if (!city || !list.includes(city)) {
        city = list[0] || ''
        persistState(primary, city)
      }
    } else if (city) {
      city = ''
      persistState(primary, city)
    }
  }
  return { primary, city }
}

function dispatchRegionChanged() {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent('region-changed', { detail: getRegionChangeDetail() }))
}

export function getRegionChangeDetail() {
  const { primary, city } = readPersistedState()
  return {
    region: getApiRegionFromParts(primary, city),
    province: primary,
    city: provinceNeedsCityPicker(primary) ? (city || null) : null
  }
}

/** 请求接口使用的地区：有省下拉且选了市时传市名，否则传省/直辖市/港澳台/海外等名称 */
export function getSelectedRegion() {
  const { primary, city } = readPersistedState()
  return getApiRegionFromParts(primary, city)
}

/** 导航栏展示：有省+市层级时只显示省名；其余显示所选名称 */
export function getNavbarRegionLabel() {
  const { primary } = readPersistedState()
  if (primary === '全国') return '全国'
  if (provinceNeedsCityPicker(primary)) return primary
  return primary
}

export function getSelectedCityLabel() {
  const { primary, city } = readPersistedState()
  if (!provinceNeedsCityPicker(primary)) return ''
  return (city || '').trim()
}

export function currentNeedsCityPicker() {
  const { primary } = readPersistedState()
  return provinceNeedsCityPicker(primary)
}

/** 列表页地区条：非全国时展示 */
export function shouldShowRegionBar() {
  const { primary } = readPersistedState()
  return (primary || '').trim() !== '全国'
}

/**
 * cities - 省及自治区：全国 + 省 + 下属市
 * direct - 直辖市/特别行政区/台湾省/海外：全国 + 当前地区
 */
export function getRegionBarMode() {
  const { primary } = readPersistedState()
  if ((primary || '').trim() === '全国') return 'hidden'
  if (provinceNeedsCityPicker(primary)) return 'cities'
  return 'direct'
}

export function getCityOptionsForCurrent() {
  const { primary } = readPersistedState()
  return getCitiesForProvince(primary) || []
}

/**
 * 顶部地区下拉选择后写入：省默认第一个市；直辖市/港澳/台湾/海外等不写市。
 */
export function setRegionFromNavbar(primaryLabel) {
  const primary = (primaryLabel && String(primaryLabel).trim()) ? String(primaryLabel).trim() : '全国'
  let city = ''
  if (provinceNeedsCityPicker(primary)) {
    const list = getCitiesForProvince(primary) || []
    city = list[0] || ''
  }
  persistState(primary, city)
  dispatchRegionChanged()
}

/** 列表页切换市 */
export function setSelectedCity(cityLabel) {
  const { primary } = readPersistedState()
  if (!provinceNeedsCityPicker(primary)) return
  const list = getCitiesForProvince(primary) || []
  const c = (cityLabel && String(cityLabel).trim()) ? String(cityLabel).trim() : ''
  if (!list.includes(c)) return
  persistState(primary, c)
  dispatchRegionChanged()
}

/** @deprecated 请使用 setRegionFromNavbar；保留别名以免外部引用报错 */
export function setSelectedRegion(region) {
  setRegionFromNavbar(region)
}
